import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamsSelector, RouterAction } from '@cbridge-packages/routing';
import { RulesManagementAction, ValidityFilterParam } from '@cbridge-modules/rules-management-page';

type IState =
  & IGetSelectorStateType<typeof queryParamsSelector>;

export const toggleValidityFilterEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RulesManagementAction.toggleValidityFilter),
  withLatestFrom(state$),
  mergeMap(([validity, state]) => {
    const currentFilters = queryParamsSelector(state, ValidityFilterParam.name);

    if (currentFilters.includes(validity)) {
      return [
        RouterAction.removeParamValue(ValidityFilterParam.nameAndValue(validity)),
      ];
    }
    return [
      RouterAction.addParamValue(ValidityFilterParam.nameAndValue(validity)),
    ];
  }),
);
